import { isEmpty, isNil } from 'lodash';
export var isAdmin = function (args) {
    if (args.fbUser) {
        var fbUser = args.fbUser;
        return (!isNil(process.env.REACT_APP_ADMIN_UID) &&
            fbUser.uid === process.env.REACT_APP_ADMIN_UID);
    }
    if (args.uid) {
        var uid = args.uid;
        return (!isNil(process.env.REACT_APP_ADMIN_UID) &&
            !isEmpty(uid) &&
            uid === process.env.REACT_APP_ADMIN_UID);
    }
    return false;
};
